module.exports = __webpack_public_path__ + "h5/img/vip7.ebcde1bf.png";